import { BaSeButton, BaSeParagraph, BaSeTheme } from '@base/react';
import React from 'react';
import { Circle, Container, Content, Row } from './legenda-style';

// import { Container } from './styles';

const arrColors = [
  {
    desc: 'Parte da resposta',
    color: '#E3FCDA',
  },
  {
    desc: 'Palavras aleatórias',
    color: '#EFDAFC',
  },
  {
    desc: 'Dúvida sobre a pergunta',
    color: '#FCDADA',
  },
  {
    desc: 'Dúvida fora do contexto da entrevista',
    color: '#EAEAEA',
  },
  {
    desc: 'Fora do contexto da entrevista',
    color: '#FCF5DA',
  },
];

function Legenda() {
  return (
    <Container>
      <BaSeButton
        buttonType="button"
        color={'#3287C6'}
        loadingText="Carregando…"
        popover={{
          direction: 'top',
          width: 330,
          renderContent: () => (
            <Content>
              {arrColors
                .sort((a, b) => {
                  if (a.desc < b.desc) {
                    return -1;
                  }
                  if (a.desc > b.desc) {
                    return 1;
                  }
                  return 0;
                })
                .map((c) => (
                  <Row key={c.color}>
                    <Circle color={c.color}></Circle>
                    <BaSeParagraph
                      color={BaSeTheme.colors.institucionais.cinzaSebrae45}
                    >
                      {c.desc}
                    </BaSeParagraph>
                  </Row>
                ))}
            </Content>
          ),
        }}
        rightIcon="exclamation-circle"
        size="small"
        type="tertiary"
        value="Legenda "
        width=""
      />
    </Container>
  );
}

export default Legenda;
